// packages/world-model/src/traits/night-vision/index.ts

export { NightVisionTrait } from './nightVisionTrait.js';
